import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  apiPrefix: any;
  headers = new HttpHeaders();

  constructor(
    private http: HttpClient
  ) {
    this.apiPrefix = environment.baseUrl + 'api/v1/dashboard/';
    this.headers = this.headers.set(
      'x-access-token',
      localStorage.getItem('adminAuthTokenTNT')
    );
  }

  getDashboardSummary(payload) {
    return this.http.post(this.apiPrefix + 'summary', payload, {
      headers: this.headers,
    });
  }
}
